/* Zenivia theme scripts — small, dependency-free enhancements.
   Every feature works without JS; these only make it nicer. */
(function () {
  'use strict';

  // Mobile menu
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    var menu = document.getElementById(btn.getAttribute('aria-controls'));
    if (!menu) return;
    btn.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // Gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('.gallery__main img');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (!main) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.getAttribute('data-src');
        main.srcset = thumb.getAttribute('data-srcset') || '';
        main.alt = thumb.getAttribute('data-alt') || main.alt;
        thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var autoSubmit = wrap.hasAttribute('data-qty-submit');
    function set(v) {
      var min = parseInt(input.min || '0', 10);
      var val = Math.max(min, v);
      if (val === parseInt(input.value, 10)) return;
      input.value = val;
      if (autoSubmit && input.form) input.form.submit();
    }
    wrap.querySelector('[data-qty-minus]').addEventListener('click', function () { set((parseInt(input.value, 10) || 1) - 1); });
    wrap.querySelector('[data-qty-plus]').addEventListener('click', function () { set((parseInt(input.value, 10) || 0) + 1); });
    if (autoSubmit) input.addEventListener('change', function () { input.form.submit(); });
  });

  // Variant select: update price + availability
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    var scope = select.closest('[data-buybox]');
    if (!scope) return;
    var priceEl = scope.querySelector('[data-price]');
    var compareEl = scope.querySelector('[data-compare-price]');
    var addBtn = scope.querySelector('[data-add-button]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      if (priceEl) priceEl.textContent = opt.getAttribute('data-price');
      if (stickyPrice) stickyPrice.textContent = opt.getAttribute('data-price');
      if (compareEl) {
        var cmp = opt.getAttribute('data-compare');
        compareEl.textContent = cmp || '';
        compareEl.hidden = !cmp;
      }
      if (addBtn) {
        var available = opt.getAttribute('data-available') === 'true';
        addBtn.disabled = !available;
        addBtn.textContent = available ? addBtn.getAttribute('data-label') : addBtn.getAttribute('data-soldout');
      }
    });
  });

  // Policy windows: open from any link to #politica-*, #informacion-contacto
  function openPolicyFromHash() {
    var id = decodeURIComponent(window.location.hash.slice(1));
    if (!id) return;
    var dialog = document.getElementById(id);
    if (dialog && dialog.classList.contains('policy-dialog') && typeof dialog.showModal === 'function' && !dialog.open) {
      document.querySelectorAll('dialog.policy-dialog[open]').forEach(function (d) { d.close(); });
      dialog.showModal();
      dialog.scrollTop = 0;
    }
  }
  document.querySelectorAll('dialog.policy-dialog').forEach(function (dialog) {
    dialog.addEventListener('close', function () {
      if (window.location.hash === '#' + dialog.id) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close(); // click on the backdrop
    });
    var closeBtn = dialog.querySelector('[data-policy-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });
  });
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#politica-"], a[href="#informacion-contacto"]');
    if (!link) return;
    var dialog = document.getElementById(link.getAttribute('href').slice(1));
    if (!dialog || typeof dialog.showModal !== 'function') return;
    e.preventDefault();
    history.pushState(null, '', link.getAttribute('href'));
    openPolicyFromHash();
  });
  window.addEventListener('hashchange', openPolicyFromHash);
  window.addEventListener('popstate', function () {
    if (!window.location.hash) document.querySelectorAll('dialog.policy-dialog[open]').forEach(function (d) { d.close(); });
    else openPolicyFromHash();
  });
  openPolicyFromHash();

  // Sticky mobile buy bar: show once the main buy form is scrolled past
  var sticky = document.querySelector('[data-sticky-buy]');
  var anchor = document.querySelector('[data-buy-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    document.body.classList.add('has-sticky-buy');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
      });
    });
    io.observe(anchor);
  }
})();
